module.exports = __webpack_public_path__ + "static/media/pictogram.0cde5a32.svg";